import React from 'react'
import { Link } from "react-router-dom";

import { Heading1, Paragraph1, Silderlogos, Button1 } from "../../../components/Ui";
import images from "../../../Utilities/index";
import EmailFinderForm from './EmailFinderForm';
import { LandingPageTestimonial, FaqSection, IdealCustomers } from "../../../components/Ui/UiComponents";


export default function Emailfinder() {

    let LostEmail = [
        { img: images.Union_21, title: "Find Email By Domain", des: "Find all email addresses on any domain in a matter of minutes. Bulk domain option is handy if you want to explore up to 20,000 domains at a time." },
        { img: images.Union_22, title: "Find Emails By Company", des: "Use our database to find just the companies you need by industry, company size, location, name and more." },
        { img: images.Union_23, title: "Get Emails From Names", des: "Know your lead’s name and company domain but not their email? We can find it for you. Use this feature to complete your prospects lists." },
    ]

    return (
        <>


            {/* First Section - Hero */}
            <section
                style={{
                    backgroundImage: `url(${images.mainbg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    padding: "2rem 0 6rem",
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <div
                    style={{
                        maxWidth: '1200px',
                        margin: '0 auto',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <img
                        src={images.emailfinder}
                        alt="email-finder"
                        style={{ width: '100%' }}
                    />
                    <div style={{ textAlign: 'center' }}>
                        <Heading1 heading1="Email Finder" />
                    </div>
                    <p
                        style={{
                            textAlign: 'center',
                            fontFamily: 'sans-serif',
                            fontWeight: '400',
                            color: '#030621',
                            fontSize: '12px',
                        }}
                    >
                        Discover the Unseen: Your Ultimate Email Finder Tool Awaits!
                    </p>
                </div>
            </section>
            {/* Second Section - Overlapping Email Finder Form */}
            <section style={{ padding: "0 1rem", marginTop: "-120px" }}>
                <EmailFinderForm />
            </section>
            {/* Slider logos here */}
            <section className="container" style={{ padding: "40px 0" }}>
                <Silderlogos />
            </section>
            {/*Info Section Grid*/}

            <section style={{ backgroundColor: '#F5F5F5', marginTop: '40px', padding: '40px 16px' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

                    {/* Title Section */}
                    <div style={{ maxWidth: '75%', textAlign: 'center', margin: '0 auto', lineHeight: '1.5' }}>
                        <Heading1 heading1="Lost In The Inbox Abyss? Our Email Finder Shines The Light!" />
                    </div>

                    {/* Flexbox Row Layout */}
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px', marginTop: '20px' }}>
                        {LostEmail.map((val, id) => (
                            <div
                                key={id}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    padding: '20px',
                                    maxWidth: '280px',
                                    background: '#ffffff',
                                    borderRadius: '8px',
                                    boxShadow: '0px 4px 6px rgba(0,0,0,0.1)'
                                }}
                            >
                                <img style={{ height: '64px', width: '64px' }} src={val.img} alt='my-img' />
                                <h4 style={{ fontSize: '20px', fontWeight: '600', marginTop: '10px' }}>{val.title}</h4>
                                <p style={{ fontSize: '14px', color: '#6B7280', marginTop: '5px' }}>{val.des}</p>
                            </div>
                        ))}
                    </div>

                </div>
            </section>

            {/*Info Action Section*/}
            <section
                style={{
                    background: "linear-gradient(to right, #56F444, #55EE44, #48FA8A)",
                    padding: "40px 0",
                }}
            >
                <div
                    style={{
                        maxWidth: "1200px",
                        margin: "0 auto",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        gap: "12px",
                    }}
                >
                    {/* Responsive styles for flex direction */}
                    <style>
                        {`
                            @media (min-width: 768px) {
                            .responsive-container { flex-direction: row; }
                            }
                        `}
                    </style>

                    <div className="responsive-container" style={{ display: "flex", width: "100%" }}>
                        <div
                            style={{
                                width: "100%",
                                maxWidth: "50%",
                                textAlign: "center",
                                lineHeight: "1.5",
                            }}
                        >
                            <Heading1 heading1="Sign Up For Free To Get 50 Searches Every Month!" />
                        </div>

                        <Link
                            to="/"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "auto",
                            }}
                        >
                            <Button1 btn1="Start to Free" />
                        </Link>
                    </div>
                </div>
            </section>

            {/*Info Steamless Connection Grid*/}
            <section
                style={{
                    maxWidth: "1200px",
                    margin: "64px auto",
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                    padding: "0 16px",
                }}
            >
                <style>
                    {`
      @media (min-width: 768px) {
        .responsive-container { flex-direction: row; }
        .responsive-text { width: 50%; padding: 40px; }
        .responsive-image { width: 50%; }
      }
    `}
                </style>

                <div className="responsive-container" style={{ display: "flex", width: "100%" }}>
                    {/* Left Section */}
                    <div className="responsive-text" style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                        <Heading1 heading1="Streamline Connections With Precision Emails" />
                        <Paragraph1 para1="In A World Where Connections Mean Everything, Introducing Our Cutting-Edge Email Finder Tool, A Game Changer For Professionals And Businesses Alike." />

                        <ul style={{ 
                            display: "grid", 
                            gridTemplateColumns: "repeat(2, 1fr)", 
                            gap: "12px", 
                            maxWidth: "600px" // Optional: To prevent spreading too wide 
                        }}>
                            <li style={{ display: "flex", gap: "8px", alignItems: "center", fontWeight: "normal" }}>
                                <images.FaCheckCircle style={{ color: "green" }} /> User-Friendly Interface
                            </li>
                            <li style={{ display: "flex", gap: "8px", alignItems: "center", fontWeight: "normal" }}>
                                <images.FaCheckCircle style={{ color: "green" }} /> Bulk Email Search
                            </li>
                            <li style={{ display: "flex", gap: "8px", alignItems: "center", fontWeight: "normal" }}>
                                <images.FaCheckCircle style={{ color: "green" }} /> Verified Results
                            </li>
                            <li style={{ display: "flex", gap: "8px", alignItems: "center", fontWeight: "normal" }}>
                                <images.FaCheckCircle style={{ color: "green" }} /> Advanced Filters
                            </li>
                        </ul>


                        <Link to="/" style={{ alignSelf: "flex-start" }}>
                            <Button1 btn3="Start to Free" />
                        </Link>
                    </div>

                    {/* Right Section */}
                    <div className="responsive-image" style={{ textAlign: "center" }}>
                        <img src={images.streamline} alt="" style={{ width: "100%", height: "auto" }} />
                    </div>
                </div>
            </section>

            {/*Info Section Grid*/}
            <section style={{ backgroundColor: "#48fa893f", padding: "40px 0" }}>
                <div
                    style={{
                        maxWidth: "1200px",
                        margin: "0 auto",
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                        padding: "0 16px",
                    }}
                >
                    <style>
                        {`
                        @media (min-width: 768px) {
                        .responsive-container { flex-direction: row; }
                        .responsive-text { width: 50%; padding: 40px; }
                        .responsive-image { width: 50%; }
                        }
                    `}
                    </style>

                    <div className="responsive-container" style={{ display: "flex", width: "100%" }}>
                        {/* Left Section - Image */}
                        <div className="responsive-image" style={{ textAlign: "center" }}>
                            <img src={images.discovercontacts} alt="" style={{ width: "100%", height: "auto" }} />
                        </div>

                        {/* Right Section - Text */}
                        <div className="responsive-text" style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                            <Heading1 heading1="Instantly Discover Contacts, Boost Outreach" />
                            <Paragraph1 para1="Say Goodbye To The Guesswork With Our User-Friendly Interface, Designed To Make Email Discovery A Simple And Enjoyable Experience." />

                            <ul style={{ 
                                        display: "grid", 
                                        gridTemplateColumns: "repeat(2, 1fr)", 
                                        gap: "12px", 
                                        maxWidth: "600px" // Optional: To prevent spreading too wide 
                                    }}>
                                 <li style={{ display: "flex", gap: "8px", alignItems: "center", fontWeight: "normal" }}>
                                    <images.FaCheckCircle style={{ color: "green" }} /> Security Measures
                                </li>
                                <li style={{ display: "flex", gap: "8px", alignItems: "center", fontWeight: "normal" }}>
                                    <images.FaCheckCircle style={{ color: "green" }} /> Responsive Support
                                </li>
                                <li style={{ display: "flex", gap: "8px", alignItems: "center", fontWeight: "normal" }}>
                                    <images.FaCheckCircle style={{ color: "green" }} /> Integration Capabilities
                                </li>
                            </ul>

                            <Link to="/" style={{ alignSelf: "flex-start" }}>
                                <Button1 btn3="Start to Free" />
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            {/*Info Section Grid*/}
            <div style={{ paddingBottom: 0, marginTop: "0px" }}>
                <FaqSection toolName={"EmailFinder"} />
            </div>

            <div style={{ paddingBottom: 0, marginBottom: "0px" }}>
                <LandingPageTestimonial />
            </div>
           
            <div style={{ paddingBottom: 0 }}>
                <IdealCustomers />
            </div>

        </>
    )
}
